import React from "react";

function MenuTitle() {
    return <h1 className="menu__title">ChillyPopper</h1>;
}

export default MenuTitle;
